import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { version, name } from '../../package.json';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://4d271374aaba4a00b1c970507c20ce34@sentry.io/1887577',
    release: `${name}@${version}`,
    // beforeSend(event, hint) {
    //  // Check if it is an exception, and if so, show the report dialog
    //  if (event.exception) {
    //    Sentry.showReportDialog({ eventId: event.event_id });
    //  }
    //  return event;
    // },
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true,
      logError: true,
    })],
  });
}

function SentrySetUser(payload) {
  if (process.env.NODE_ENV === 'production') Sentry.setUser(payload);
}

export default SentrySetUser;
